import type { PageWidgetsLayout } from "./types";

function widgetsGridWithType<T extends Record<string, PageWidgetsLayout>>(
	map: {
		[K in keyof T]: T[K];
	},
): { [K in keyof T]: T[K] & { page: string } } {
	return Object.fromEntries(Object.entries(map).map(([key, value]) => [key, { ...value, page: key }])) as {
		[K in keyof T]: T[K] & { page: string };
	};
}

export const defaultWidgetsGridConfig = widgetsGridWithType({
	PORTFOLIO_DETAILS: {
		widgets: [
			{ i: "PortfolioPerformance", span: 2, minSpan: 2, maxSpan: 2 },
			{ i: "PortfolioMonitoringBlock", span: 1, minSpan: 1, maxSpan: 1 },
			{ i: "PerformanceMetricsBlock", span: 1, minSpan: 1, maxSpan: 1 },
			{ i: "ExanteMetricsBlock", span: 1, minSpan: 1, maxSpan: 1 },
			{ i: "PortfolioCommentaryMDBlock", span: 1, minSpan: 1, maxSpan: 1 },
			{ i: "ExposureEvolve", span: 2, minSpan: 2, maxSpan: 2 },
			{ i: "MaturityCouponTracker", span: 1, minSpan: 1, maxSpan: 1 },
			{ i: "BondsDividendsTracker", span: 2, minSpan: 2, maxSpan: 2 },
			{ i: "PortfolioHistoryBlock", span: 1, minSpan: 1, maxSpan: 1 },
			{ i: "Attribution", span: 3, minSpan: 3, maxSpan: 3 },
			{ i: "ContributionVolatility", span: 3, minSpan: 3, maxSpan: 3 },
			{ i: "ExanteContributionVolatility", span: 3, minSpan: 3, maxSpan: 3 },
			{ i: "PortfolioFactorsExposure", span: 3, minSpan: 3, maxSpan: 3 },
		],
	},
	PORTFOLIO_ENHANCEMENT: {
		widgets: [
			{ i: "ExposureCompare", span: 2, minSpan: 2, maxSpan: 2 },
			{ i: "PortfolioCommentaryMDBlock", span: 1, minSpan: 1, maxSpan: 1 },
			{ i: "ExanteContributionVolatility", span: 2, minSpan: 2, maxSpan: 2 },
			{ i: "ExanteMetricsBlock", span: 1, minSpan: 1, maxSpan: 1 },
			{ i: "PortfolioFactorsExposure", span: 2, minSpan: 2, maxSpan: 2 },
			{ i: "PortfolioMonitoringBlock", span: 1, minSpan: 1, maxSpan: 1 },
		],
	},
	PORTFOLIO_REFERENCE: {
		widgets: [
			{ i: "ExposureEvolve", span: 3, minSpan: 3, maxSpan: 3 },
			{ i: "Composition", span: 3, minSpan: 3, maxSpan: 3 },
		],
	},
	ASSET_CLASS: {
		widgets: [
			{ i: "ACROutlookExpected", span: 1, minSpan: 1, maxSpan: 1 },
			{ i: "ReturnAnalysis", span: 2, minSpan: 2, maxSpan: 2 },
			{ i: "FactorsExposure", span: 2, minSpan: 2, maxSpan: 2 },
		],
	},
	DASHBOARD: {
		widgets: [
			{ i: "AssetClassOverviewBlock", span: 3, minSpan: 3, maxSpan: 3 },
			{ i: "OutlookBlock", span: 3, minSpan: 3, maxSpan: 3 },
			{ i: "CommentaryMDBlock", span: 2, minSpan: 2, maxSpan: 2 },
		],
	},
	OUTLOOK: {
		widgets: [
			{ i: "Positioning", span: 3, minSpan: 3, maxSpan: 3 },
			{ i: "Forecast", span: 2, minSpan: 2, maxSpan: 2 },
			{ i: "CommentaryMDBlock", span: 1, minSpan: 1, maxSpan: 1 },
		],
	},
	HMM: {
		widgets: [
			{ i: "MarketRegimeAnalysisBlock", span: 1, minSpan: 1, maxSpan: 1 },
			{ i: "ScenarioDescriptionBlock", span: 2, minSpan: 2, maxSpan: 2 },
			{ i: "PastMarketRegimesBlock", span: 3, minSpan: 3, maxSpan: 3 },
			{ i: "EvolutionOfRegimeProbabilitiesBlock", span: 3, minSpan: 3, maxSpan: 3 },
			{ i: "RegimeTransitionMatrix2WBlock", span: 1, minSpan: 1, maxSpan: 1 },
			{ i: "RegimeTransitionMatrix1MBlock", span: 1, minSpan: 1, maxSpan: 1 },
			{ i: "RegimeTransitionMatrix3MBlock", span: 1, minSpan: 1, maxSpan: 1 },
			{ i: "RegimeBreakdownBySectorBlock", span: 3, minSpan: 3, maxSpan: 3 },
			{ i: "CurrentRegimeCounterBlock", span: 1, minSpan: 1, maxSpan: 1 },
		],
	},
});
